const distanciaAlSiguienteDia = (dias, diaActual, incluirDiaActual = false) => {
    // Orden de los días de la semana
    const diasOrdenados = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];

    // Obtener los índices de los días activados (true)
    const indices = diasOrdenados
        .map((dia, index) => (dias[dia] ? index : null))
        .filter(index => index !== null);

    if (indices.length === 0) {
        return -1; // Si no hay días activados, devolver -1 (indica que no hay destino)
    }

    // Obtener el índice del día actual
    const indiceActual = diasOrdenados.indexOf(diaActual);
    if (indiceActual === -1) {
        throw new Error(`El día '${diaActual}' no es válido.`);
    }

    // Si el día actual está activo y la bandera indica incluirlo, retornar 0
    if (incluirDiaActual && dias[diaActual]) {
        return 0;
    }

    // Encontrar el siguiente día activado (circularmente)
    for (let i = 1; i <= 7; i++) {
        const indiceSiguiente = (indiceActual + i) % 7;
        if (indices.includes(indiceSiguiente)) {
            return i; // Retornar la distancia en días
        }
    }

    return -1; // Esto no debería suceder si hay días activados
}

module.exports = {
    distanciaAlSiguienteDia
};